import { MessagePlugin } from 'tdesign-vue';
import { Ref, ref, getCurrentInstance, ComponentInternalInstance } from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
import ipc from '@/renderer/scripts/utils/ipc';
import errorCodeMap from '@/renderer/scripts/utils/errorCode/index';
import tips, { MsgError } from '@/renderer/scripts/utils/tips';
import smh, { SMH } from '@/renderer/scripts/smh';
type Item = {
  name: string;
  type: string;
  path: string[];
  authorityList: SMH.AuthorityList;
};
type OperateItem = {
  name: string;
  force: string;
  currPath: string;
};
type Handler = {
  show: Ref<boolean>;
  originName: Ref<string>;
  type: Ref<string>;
  methods: {
    openRenameFolder: (item: Item) => void;
    renameAuth: (task: Item) => Promise<void>;
    onRenameFolder: (operateItem: OperateItem) => Promise<void>;
    errReset: (info: string) => void;
  };
  renameError: Ref<string>;
};
export default function handler(spaceId: Ref<SpaceId>, fromFavor?: boolean): Handler {
  const originPath = ref<string[]>([]); // 原始全路径
  const show = ref(false);
  const originName = ref('');
  const type = ref('');
  const renameError = ref('');
  const methods = {
    async renameAuth(task: Item) {
      /**
       * 重命名权限两种:
       * 1、文件本身有canModify
       * 2、文件本身有下载+删除+父目录的上传权限
       * TODO: 权限组合后续由后端来统一判断
       */
      if (task.authorityList && task.authorityList.canDelete && task.authorityList.canDownload) {
        const opt = {
          page: 1,
          pageSize: 1,
          dirPath: task.path.slice(0, -1).join('/'),
          spaceId: spaceId.value,
        };
        try {
          const { data: resData } = await smh.commonAPI.listDirectory(opt);
          if (resData.authorityList && resData.authorityList.canUpload) {
            methods.openRenameFolder(task);
          } else {
            tips.warning(i18n_t('暂无操作权限，请联系管理员'));
          }
        } catch (error) {
          tips.error(error as MsgError);
        }
      } else {
        tips.warning(i18n_t('暂无操作权限，请联系管理员'));
      }
    },
    openRenameFolder(item: Item) {
      originPath.value = item.path as string[];
      show.value = true;
      originName.value = item.name;
      type.value = item.type;
      renameError.value = '';
    },
    async onRenameFolder(operateItem: OperateItem) {
      tips.loading(i18n_t('重命名中'));
      const originPathStr = originPath.value.join('/');
      let newPath = originPath.value.slice(0, -1);
      newPath.push(operateItem.name);
      const newPathStr = newPath.join('/');
      try {
        if (type.value === 'dir') {
          const { data } = await smh.commonAPI.renameOrMoveDirectory({
            dirPath: newPathStr,
            from: originPathStr,
            conflictResolutionStrategy: 'ask',
            spaceId: spaceId.value,
            moveAuthority: true,
          });
          // 文件夹重命名不返回新的path
          newPath = data?.path || newPath;
        } else {
          const { data } = await smh.commonAPI.renameOrMoveFile({
            filePath: newPathStr,
            from: originPathStr,
            conflictResolutionStrategy: operateItem.force,
            spaceId: spaceId.value,
          });
          newPath = data?.path || newPath;
        }
        tips.success(i18n_t('重命名成功'));
        show.value = false;
        ipc.emit(
          ipc.RENDERER_EVENTS_MAP.COMMAND_REFRESH,
          {
            originPathStr: originPath.value,
            path: newPath,
          },
          'rename',
        );
        fromFavor && ipc.emit(ipc.RENDERER_EVENTS_MAP.FAVOR_LIST_FRESH);
      } catch (error: any) {
        renameError.value = errorCodeMap[error.code];
        MessagePlugin.closeAll();
        // tips.error(error);
      }
    },

    errReset() {
      renameError.value = '';
    },
  };
  return {
    show,
    originName,
    type,
    methods,
    renameError,
  };
}
